uniform sampler2D uMap;
uniform vec3 uColor;
uniform float uOpacity;

varying vec2 vUv;

void main() {
    vec3 tex = texture2D(uMap, vUv).rgb;
    float alpha = tex.r * uOpacity;
    gl_FragColor = vec4(uColor, alpha);
}


